'use client';

import { createContext, useMemo, useState } from 'react';

import { createLocaleMap } from '../../utils/i18n';

import type { LanguageMap } from '../../utils/i18n';
import type { PropsWithChildren } from 'react';

interface HreflangContextState {
  hrefLangMap: LanguageMap;
  setHrefLangMap: (map: LanguageMap) => void;
}

export const HreflangContext = createContext<HreflangContextState | undefined>(undefined);

export function HreflangProvider({ children }: PropsWithChildren) {
  const [hrefLangMap, setHrefLangMap] = useState<LanguageMap>(createLocaleMap(''));
  const value = useMemo(
    () => ({
      hrefLangMap,
      setHrefLangMap
    }),
    [hrefLangMap]
  );

  return <HreflangContext.Provider value={value}>{children}</HreflangContext.Provider>;
}
